/** @jsxImportSource @emotion/react */
import { styles } from './CareersSection.styles';
import { useJobs } from '../../hooks/useJobs';
import JobsFilters from '../JobsFilters/JobsFilters';
import JobsListExpand from '../JobsListExpand/JobsListExpand';
import JobsPagination from '../JobsPagination/JobsPagination';

export default function CareersSection() {
  const {
    jobs,
    skills,
    locations,
    types,
    loading,
    filters,
    setFilters,
    pagination,
    setPagination,
  } = useJobs();

  const hasVacancies = jobs.length > 0;

  if (loading) {
    return (
      <section css={styles.wrapper}>
        <div css={styles.noVacancies}>Loading vacancies...</div>
      </section>
    );
  }

  if (!hasVacancies) {
    return (
      <section css={styles.wrapper}>
        <div css={styles.noVacancies}>
          There are currently no open vacancies.
        </div>
      </section>
    );
  }

  return (
    <section css={styles.wrapper}>
      <div css={styles.grid}>
        <JobsFilters
          filters={filters}
          setFilters={setFilters}
          skills={skills}
          locations={locations}
          types={types}
        />

        <div css={styles.rightColumn}>
          <JobsListExpand jobs={jobs} />

          {pagination.pageCount > 1 && (
            <JobsPagination
              pagination={pagination}
              setPagination={setPagination}
            />
          )}
        </div>
      </div>
    </section>
  );
}
